{
	"checkWebGL": "Check WebGL support",
	"isNotAvailable": "{{name}} is not available",
	"requiresToFunction": "{{var0}} requires {{name}} to function."
}
